import coreStore from '../persistence/coreStore';

function clientReduxErrorReporter(error, getState, lastAction) {
  if (coreStore.load('debugLogging')) {
    console.log(error);
  }
}

export default clientReduxErrorReporter;
